import { useState, MouseEvent } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import MoreVert from "@material-ui/icons/MoreVert";
import Edit from "@material-ui/icons/Edit";
// import Delete from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { useTableActionStyles } from "./styles";
import { AttendanceLocalDepartmentGuiche } from "../../../../../../../../../../../../../@types/attendance-local-department-guiche";
import GuicheFormUpdate from "../../../form/update";
import DesktopWindows from "@material-ui/icons/DesktopWindows";
// import GuicheDelete from "../../../../../../../guiche-delete";

type TableActionsProps = {
  guiche: AttendanceLocalDepartmentGuiche;
}

export default function TableActions({ guiche }: TableActionsProps) {
  const { pathname } = useLocation();
  const { slug, id } = useParams<{ slug: string, id: string }>();
  const { classes } = useTableActionStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreVert />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        keepMounted
      >
        <MenuItem
          component={Link}
          onClick={handleClose}
          className={classes.menuItem}
          to={`${pathname}/guiche/${guiche.id}/${guiche.tipo === 'Interno' ? 'servicos-complementares' : 'servicos'}`}
        >
          <DesktopWindows htmlColor="#706E7A" />
          {guiche.tipo === 'Interno' ? 'Serviços Complementares' : 'Serviços'}
        </MenuItem>
        <GuicheFormUpdate
          departmentId={Number(id)}
          guiche={guiche}
          slug={slug}
          buttonTrigger={
            <MenuItem
              onClick={handleClose}
              className={classes.menuItem}
            >
              <Edit htmlColor="#706E7A" />
              Editar
            </MenuItem>
          }
        />
        {/* <GuicheDelete
          guiche={guiche}
          buttonTrigger={
            <MenuItem
              onClick={handleClose}
              className={classes.menuItem}
            >
              <Delete htmlColor="#706E7A" />
              Excluir
            </MenuItem>
          }
        /> */}
      </Menu>
    </>
  );
}
